import {
  Component,
  OnInit,
  Directive,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AreasService } from "../../master-services/area-services/areas.service";
import swal from "sweetalert2";
import { DecimalPipe } from "@angular/common";
import { Console, error } from "console";
import { OrderService } from "../../master-services/order-service/orderservice.service";
import {
  NgbCalendar,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";

///¡¡¡¡¡Importaciones nuevas

////Termina Importaciones nuevas de la tabla

@Component({
  selector: "app-master-imports-basket",
  templateUrl: "./master-imports-basket.component.html",
  styleUrls: ["./master-imports-basket.component.scss"],
})
export class MasterimportsBasketComponent implements OnInit {
  ////Comienza Espacio para declaraciones /////

  priceListMap: { [key: number]: string } = {
    0: "Seleccionar país",
    2: "USA",
    3: "ESPAÑA",
    4: "BELGICA",
    5: "SERVICIO TERCERO",
    6: "REPUESTO NACIONAL",
    7: "SIN",
    8: "USA FPE",
    9: "FLORIDA",
    10: "KANSAS",
    11: "MPE",
  };

  stateListMap: { [key: number]: string } = {
    0: "En canasta",
    1: "Llego el pedido",
    2: "Despachado",
  };

  priceListArray: { key: number; value: string }[] = [];
  consecutive: any;
  now: any;
  user: any;
  selectedOriginId: number = 0;
  state: number = 0;
  import_order: any;
  filteredOrders: any;
  emailLogist: any;
  orderserviceslogist: any;
  ordersFlat: any;

  ///Tabla
  secondImportOder: any[] = [];
  selectedOrders: any[] = [];
  totalWeight: number = 0;
  totalPLD: number = 0;
  showAssignement: boolean = false;
  importOrder: any;
  

  orderBy: string = ""; // Campo por el que se ordena
  orderDirection: boolean = true; // true = ascendente, false = descendente
  ///Termina tabla
  ////Termina Espacio para declaraciones /////
  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private orderservice: OrderService,
    private calendar: NgbCalendar
  ) {
    this.index();
  }
  ngOnInit() {}

  index() {
    //Obtencion de data

    console.warn("Iniciando el componente");
    this.getOrderLogist();
    this.getImportOrder();

    ///Obtener fecha y usuario
    var date = new Date();
    var day = (date.getDate() < 10 ? "0" : "") + date.getDate();
    let month = (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);
    var year = date.getFullYear();
    this.now = year + "-" + month + "-" + day;
    this.user = localStorage.getItem("username");
  }

  /////+++ ACA COMIENZO FUNCIONES DE ESTE COMPONENTE BASKET
  go_basket() {
    this.router.navigateByUrl("erp/import_basket");
  }

  getOrderLogist() {
    console.log("Acaaa haciendo el get");
    this.orderservice
      .getOrderserviceLogisBasket()
      .then((data) => {
        const resp: any = data;

        swal.close();
        this.orderserviceslogist = resp.data;
        console.log(
          "Data recibida de ordenes logistica:",
          this.orderserviceslogist
        );

        this.ordersFlat = this.orderserviceslogist.flatMap(
          (item) => item.orders
        );

        console.log("Nuevo array sin agrupación:", this.ordersFlat);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  formatToThreeDecimals(value: number): string {
    if (value === undefined || value === null || isNaN(value)) {
      // Retorna un valor por defecto si el valor no es válido
      return "0.00";
    }
  }

  getPriceListName(priceList: number): string {
    return this.priceListMap[priceList] || "Desconocido";
  }

  /////+++ ACA TERMINO FUNCIONES DE ESTE COMPONENTE BASKET

  ////Acaaa pruieba de tablas en canasta

  setOrder(field: string) {
    if (this.orderBy === field) {
      this.orderDirection = !this.orderDirection;
    } else {
      this.orderBy = field;
      this.orderDirection = true;
    }

    this.ordersFlat.sort((a: any, b: any) => {
      const valueA = a[field];
      const valueB = b[field];

      // Verificar si es un número o un string
      if (typeof valueA === "number" && typeof valueB === "number") {
        return this.orderDirection ? valueA - valueB : valueB - valueA;
      } else {
        return this.orderDirection
          ? valueA.toString().localeCompare(valueB.toString())
          : valueB.toString().localeCompare(valueA.toString());
      }
    });
  }

  toggleSelection(order: any) {
    const index = this.selectedOrders.findIndex((o) => o.id === order.id);

    if (index === -1) {
      // Si no está en la lista, lo agregamos
      this.selectedOrders.push(order);
    } else {
      // Si ya está en la lista, lo quitamos
      this.selectedOrders.splice(index, 1);
    }

    // Recalcular los valores totales después de cada selección
    this.totalWeight = this.selectedOrders.reduce(
      (sum, o) => sum + o.cant_imports * parseFloat(o.weight),
      0
    );
    this.totalPLD = this.selectedOrders.reduce(
      (sum, o) => sum + parseFloat(o.unit_cost) * o.cant_imports,
      0
    );

    console.log("Seleccionados:", this.selectedOrders);
    console.log("Peso Total:", this.totalWeight);
    console.log("PLD Total:", this.totalPLD);
  }

  ////Aca termina pruebas canasta

  assignDataSelected() {
    console.log("Holaaa aca cambiare de estados");
    console.log("acaa Todas las ordenes", this.selectedOrders);
    this.showAssignement = true;
  }

  // backAssignDataSelected(){
  //   console.log("Holaaa aca cambiare de estados")
  //   this.showAssignement=false
  // }

  getImportOrder() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservice
      .getImportOrderBasket()
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.import_order = resp.data;
        console.log("Data recibida de Importorders:", this.import_order);
        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  removeOrder(order: any) {
    console.log("acaa remuevo la orden", order);
    console.log("acaa Todas las ordenes", this.selectedOrders);
    const index = this.selectedOrders.findIndex((o) => o.id === order.id);
    if (index !== -1) {
      this.selectedOrders.splice(index, 1);

      this.totalWeight = this.selectedOrders.reduce(
        (sum, o) => sum + o.cant_imports * parseFloat(o.weight),
        0
      );
      this.totalPLD = this.selectedOrders.reduce(
        (sum, o) => sum + parseFloat(o.unit_cost) * o.cant_imports,
        0
      );

      swal({
        title: "Se Elimino el item",
        text: "Correcto",
        type: "success",
      });
    }

    console.log("Órdenes después de eliminar:", this.selectedOrders);
    console.log("Totales:", this.totalPLD);
    console.log("Totales Peso aca:", this.totalWeight);
  }

  addImportOrder(order: any) {
    if (!order.importDetails) {
      order.importDetails = [];
    }
    order.importDetails.push({
      import_order_consecutive: "",
      other_cant_imports: null,
    });
  }

  removeImportField(order: any, index: number) {
    order.importDetails.splice(index, 1);
  }

  confirmNewImportOrderDetail(order: any) {
    console.log("Acaaa paso la ", order);

    // Calcula la suma de las cantidades ingresadas en los inputs
    const totalQuantityEntered = order.importDetails.reduce(
      (sum: number, importDetail: any) => {
        return sum + (importDetail.other_cant_imports || 0);
      },
      0
    );

    // Verifica si la suma de las cantidades es igual a order.cant_imports
    if (totalQuantityEntered !== order.cant_imports) {
      console.warn(
        `La cantidad total ingresada (${totalQuantityEntered}) no coincide con la cantidad de importación (${order.cant_imports}).`
      );
      swal({
        title: "Las cantidades deben coincidir",
        text: "Error",
        type: "error",
      });
      return;
    }

    // Si la validación pasa, se genera el array newImportData
    const newImportData = order.importDetails.map((importDetail: any) => ({
      order_service_consecutive: order.order_service_consecutive,
      import_order_consecutive: importDetail.import_order_consecutive,
      cant_disp: order.cant_disp,
      cant_imports: order.cant_imports,
      crossReferenceCode: order.crossReferenceCode,
      customer_name: order.customer_name,
      description: order.description,
      estimate_consecutive: order.estimate_consecutive,
      order_observation: order.order_observation,
      price_list: order.price_list,
      quantity: order.quantity,
      unit_cost: order.unit_cost,
      warehouse_description: order.warehouse_description,
      weight: order.weight,
      weight_type: order.weight_type,
      quantity_toImport: importDetail.other_cant_imports,
      code: order.code,
      id: order.id,
      od_id: order.od_id,
      petitioner_email:order.petitioner_email,
      comercial_name:order.comercial_name,
    }));

    // Agregar los datos validados al array this.secondImportOder y sacarlo del primero
    this.secondImportOder.push(...newImportData);

    this.selectedOrders = this.selectedOrders.filter(
      (selectedOrder: any) => selectedOrder.id !== order.id
    );
    this.totalWeight = this.selectedOrders.reduce(
      (sum, o) => sum + o.cant_imports * parseFloat(o.weight),
      0
    );
    this.totalPLD = this.selectedOrders.reduce(
      (sum, o) => sum + parseFloat(o.unit_cost) * o.cant_imports,
      0
    );
    console.log("Datos de importación confirmados:", newImportData);
    console.log(
      "Orden eliminada de selectedOrders, nuevo estado:",
      this.selectedOrders
    );
    console.log("segundo array de ordenes:", this.secondImportOder);
  }

  createImportOrderDetail() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    console.log("Acaa pedido de improtacion", this.importOrder);
    console.log("Órdenes después :", this.selectedOrders);
    console.log("Órden creada manualmente :", this.secondImportOder);
    const roundToTwoDecimals = (value: string | number) =>
      parseFloat(value as string).toFixed(2);
    const updatedSelectedOrders = this.selectedOrders.map((order) => ({
      importOrderConsecutive: Number(this.importOrder),
      estimateConsecutive: order.estimate_consecutive,
      code: order.code,
      quantity_toImport: order.cant_imports,
      cant_disp: 0,
      PID_unit: Number(roundToTwoDecimals(order.unit_cost)),
      weight: Number(roundToTwoDecimals(order.weight)),
      cant_imports: order.cant_imports,
      total_quantity: order.quantity,
      product_arrived: 0,
      product_remision: 0,
      product_registered: 0,
      cant_registered: 0,
      produtc_dispatch: 0,
      stock: 0,
      description: order.description,
      orderserviceConsecutive: order.order_service_consecutive,
      od_id: order.od_id,
      customer_name: order.customer_name,
      warehouse_description: order.warehouse_description,
      order_logis_id: order.id,
      petitioner_email:order.petitioner_email,
      comercial_name:order.comercial_name,
    }));

    const updatedSecondOrders = this.secondImportOder.map((order) => ({
      importOrderConsecutive: Number(order.import_order_consecutive),
      estimateConsecutive: order.estimate_consecutive,
      code: order.code,
      quantity_toImport: order.quantity_toImport,
      cant_imports: order.quantity_toImport,
      cant_disp: 0,
      PID_unit: Number(roundToTwoDecimals(order.unit_cost)),
      weight: Number(roundToTwoDecimals(order.weight)),
      total_quantity: order.quantity,
      product_arrived: 0,
      product_remision: 0,
      product_registered: 0,
      cant_registered: 0,
      produtc_dispatch: 0,
      stock: 0,
      description: order.description,
      orderserviceConsecutive: order.order_service_consecutive,
      od_id: order.od_id,
      customer_name: order.customer_name,
      warehouse_description: order.warehouse_description,
      order_logis_id: order.id,
      petitioner_email:order.petitioner_email,
      comercial_name:order.comercial_name,
    }));

    console.log(
      "🚀 Órdenes después con importOrder agregado:",
      updatedSelectedOrders
    );
    console.log(
      "ACAAAA segunda Órdenes después con importOrder agregado:",
      updatedSecondOrders
    );

    const combinedOrders = [...updatedSelectedOrders, ...updatedSecondOrders];

    console.log(
      "🚀 Órdenes combinadas con importOrder agregado:",
      combinedOrders
    );

    ////Acaaa combino ids para actualizar el stado de orderlogist State Basket
    const selectedOrdersIds = this.selectedOrders.map((order) => order.id);
    const secondImportOrderIds = this.secondImportOder.map((order) => order.id);
    const combinedIds = [...secondImportOrderIds, ...selectedOrdersIds].filter(
      (id, index, array) => {
        return array.indexOf(id) === index;
      }
    );
    
    console.warn("ids Para cambiar de estado:", combinedIds);
   

    ////Aca construyo servicio para actualizar y pasar ids
    
     this.orderservice.createImportOrderDetail(combinedOrders).then((data) => {
       if (data && typeof data === "object" && "success" in data) {
         console.log("Se ha creado el post", data);
         swal({
           title: "Se ha registrado los pedidos de importacion",
           type: "success",
         });
         const updateData = {
           id: combinedIds,
           stateBasket: 1,
         };
         console.log("Acaaa data para actualizar ids. ", updateData);

         this.updateStateBasket(updateData);
       } else {
         console.log("Error al crear POSTLOGIST:", data);
         // Manejo Adicional de errores
         swal.close();
         swal({
           title: "Los items deben de asociarse a un numero de pedido",
           type: "error",
         });
       }
     });
     
  }

  updateStateBasket(combinedIds: any) {
    console.log("Aca data para actualizar", combinedIds);
    
        ///Formateo de fecha para pasarla en actualizacion si se necesita.
        const now = new Date();
        const localISOTime = new Date(
          now.getTime() - now.getTimezoneOffset() * 60000
        ).toISOString();
        const updateData = {
          id: combinedIds,
          stateBasket: 1,
          
        };
        console.log("Aca pasando Ids para actualizar", updateData);
        this.orderservice.updateStateBasketselect(updateData).then((data) => {
          if (data && typeof data === "object" && "success" in data) {
            console.log("Se ha creado la actualizacion de imports Detail", data);
            swal({
              title: "Se ha cambiado El estato",
              type: "success",
            });
            swal.close();
            this.router.navigateByUrl("erp/Importsorder");
          } else {
            console.log("Error al crear POSTLOGIST:", data);
            // Manejo Adicional de errores
          }
        });
  }
    
    

  ////

}



// WEBPACK FOOTER //
// ./src/app/master/master-imports-basket/master-imports-basket.component.ts